module.exports = __webpack_public_path__ + "static/media/bankLogo.4828a3df.svg";